import { render, staticRenderFns } from "./ForbiddenPage.vue?vue&type=template&id=5a963609&"
import script from "./ForbiddenPage.vue?vue&type=script&lang=js&"
export * from "./ForbiddenPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports